import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import SitecorecontextFactory from '../../../lib/SitecoreContextFactory';
import TextInput from '../../../lib/ui/form_elements/TextInput';
import Search from '../../../assets/icons/Search.svg';
import { Locales } from '../../../utils/enums';

class SearchTable extends PureComponent {
  getSearchResults = (e) => {
    const searchKey = e.target.value;
    this.props.getSuggestions(searchKey);
  };

  render() {
    return (
      <>
        {(SitecorecontextFactory.context.language === Locales.English) && (
          <TextInput
            placeholder="Search"
            icon={{ src: Search, alt: 'Search', onClick: () => { this.getSearchResults(); } }}
            input={{
              onChange: (event) => this.getSearchResults(event),
              onKeyDown: (event) => {
                if (event.charCode === 13 || event.keyCode === 13) {
                  event.preventDefault();
                  event.stopPropagation();
                  this.getSearchResults(event);
                }
              },
            }}
          />
        )}
        {(SitecorecontextFactory.context.language === Locales.French) && (
          <TextInput
            placeholder="Rechercher"
            icon={{ src: Search, alt: 'Rechercher', onClick: () => { this.getSearchResults(); } }}
            input={{
              onChange: (event) => this.getSearchResults(event),
              onKeyDown: (event) => {
                if (event.charCode === 13 || event.keyCode === 13) {
                  event.preventDefault();
                  event.stopPropagation();
                  this.getSearchResults(event);
                }
              },
            }}
          />
        )}
      </>
    );
  }
}

SearchTable.propTypes = {
  getSuggestions: PropTypes.func,
};

export default SearchTable;
